import request from '@/utils/request'
// 提交idfa 和通讯录
function addressBook () {
  const contant = getContactsFromStorage()
  const idfa = localStorage.getItem('idfa') || ''
  if (contant || idfa) {
    const contantList = JSON.stringify(contant) || JSON.stringify([])
    request.post('addressBook', { contantList, idfa: idfa.replace(/"/g, '') })
  }
}

// 兼容多种通讯录储存到localStorage的key
export function getContactsFromStorage () {
  const keyList = [
    {
      contactKey: 'contact',
      name: 'accountName',
      phone: 'accountPhone'
    },
    {
      contactKey: 'ijksfas',
      name: 'qwjnds',
      phone: 'diwhdf'
    },
    {
      contactKey: 'hgdfs',
      name: 'asdew',
      phone: 'vsdgf'
    },
    {
      contactKey: 'wpoojns',
      name: 'dasdw',
      phone: 'qweas'
    },
    {
      contactKey: 'vnfhdvk',
      name: 'qbvhsd',
      phone: 'ohfuei'
    },
    {
      contactKey: 'lnhkj',
      name: 'hcsghi',
      phone: 'qhvfd'
    },
    {
      contactKey: 'onvhj',
      name: 'qjvhsu',
      phone: 'iryui'
    },
    {
      contactKey: 'fsdds',
      name: 'vcew',
      phone: 'sdgff'
    },
    {
      contactKey: 'fbfes',
      name: 'bcsd',
      phone: 'fbbr'
    },
    {
      contactKey: 'dfxc',
      name: 'dfgd',
      phone: 'swee'
    },
    {
      contactKey: 'dgdfes',
      name: 'sdfx',
      phone: 'sweg'
    },
    {
      contactKey: 'ersdf',
      name: 'wewd',
      phone: 'wewr'
    },
    {
      contactKey: 'ewwdfsd',
      name: 'sdfs',
      phone: 'dswe'
    },
    {
      contactKey: 'khruei',
      name: 'cjfheuw',
      phone: 'shjfy'
    },
    {
      contactKey: 'rewrwer',
      name: 'gdfge',
      phone: 'grtrt'
    },
    {
      contactKey: 'qwqease',
      name: 'ewsd',
      phone: 'qweqff'
    },
    {
      contactKey: 'sweerfss',
      name: 'fsdwe',
      phone: 'sdfwsew'
    },
    {
      contactKey: 'wersdfsdf',
      name: 'fdsfws',
      phone: 'dferer'
    },
    {
      contactKey: 'asdjhfd',
      name: 'sdfwe',
      phone: 'vfdsd'
    },
    {
      contactKey: 'ljkhgf',
      name: 'uhgds',
      phone: 'fbtyh'
    },
    {
      contactKey: 'ajhsf',
      name: 'iwhufis',
      phone: 'mbfgey'
    },
    {
      contactKey: 'sfgthykg',
      name: 'fdsj',
      phone: 'fhjty'
    },
    {
      contactKey: 'ioiuyt',
      name: 'mngfe',
      phone: 'rferfsd'
    },
    {
      contactKey: 'dfgerw',
      name: 'gjtr',
      phone: 'retes'
    },
    {
      contactKey: 'kiuyifg',
      name: 'sfwefsd',
      phone: 'hgjtyh'
    },
    {
      contactKey: 'lshjkf',
      name: 'fjahgd',
      phone: 'cbhduw'
    },
    {
      contactKey: 'rwersdfs',
      name: 'fwesd',
      phone: 'vcdf'
    },
    {
      contactKey: 'irwejjje',
      name: 'grwwer',
      phone: 'ffgwe'
    },
    {
      contactKey: 'luwhff',
      name: 'pqhvdis',
      phone: 'bfuehwu'
    },
    {
      contactKey: 'mheuwa',
      name: 'rosnjhds',
      phone: 'pqjhvduis'
    },
    {
      contactKey: 'lkujyhgf',
      name: 'srwefds',
      phone: 'xfvsrtwe'
    },
    {
      contactKey: 'grthyt',
      name: 'dfwe',
      phone: 'sdfsdger'
    }

  ]
  let contant = ''
  // 使用some方法，当找到有值的key时会自动终止循环
  keyList.some(key => {
    const valueJSON = localStorage.getItem(key.contactKey)
    if (valueJSON) {
      const valueArray = JSON.parse(valueJSON)
      contant = valueArray.map(item => ({
        accountName: item[key.name],
        accountPhone: item[key.phone]
      }))
      return true
    }
    return false
  })
  return contant
}
export default addressBook
